import { DropdownMenu, Typography, TableListActions } from 'seagull';
import { TrashLiner24 } from 'seagull/icons';
import { useOnMount } from "../../../../hooks/useOnMount";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const DeleteServiceActionContent = _ref => {
  let {
    service,
    draft,
    setDraft
  } = _ref;
  useOnMount(() => {
    setDraft(draft.removeService(service.id));
  });
  return /*#__PURE__*/_jsxs(Typography, {
    children: ["Are you sure you want to delete service \"", service.name, "\"?"]
  });
};
export default function DeleteServiceAction(_ref2) {
  let {
    service,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref2;
  const onClick = () => {
    onOpenModal({
      skin: 'danger',
      submitOnNotDirty: true,
      renderContent: _ref3 => {
        let {
          draft,
          setDraft
        } = _ref3;
        return {
          primaryButtonLabel: 'Delete service',
          title: 'Delete service',
          testid: "delete-service-modal-".concat(service.id),
          content: /*#__PURE__*/_jsx(DeleteServiceActionContent, {
            service: service,
            draft: draft,
            setDraft: setDraft
          }),
          onSubmit: defaultBehavior => {
            defaultBehavior();
          }
        };
      }
    });
  };
  return /*#__PURE__*/_jsx(TableListActions, {
    testId: "table-list-actions-".concat(service.id),
    children: /*#__PURE__*/_jsx(DropdownMenu.Item, {
      skin: "error",
      iconStart: /*#__PURE__*/_jsx(TrashLiner24, {}),
      onClick: onClick,
      "data-testid": "table-list-actions-delete-".concat(service.id),
      disabled: isDisabled,
      tooltipProps: {
        title: disabledTooltip,
        placement: 'right'
      },
      children: "Delete Service"
    })
  });
}